<template>
  <div>
    <v-combobox
      :disabled="!canChoiceRegion"
      :dark="dark"
      persistent-hint
      hide-selected
      v-model="currentSite"
      :items="sites"
      item-value="key"
      item-text="name"
      :label="label"
    ></v-combobox>
    <input
      v-if="input"
      type="text"
      :name="fieldName"
      v-model="currentSite.key"
      style="display: none"
    />
  </div>
</template>

<script>
import userMixin from '@/mixins/user'

export default {
  name: 'SiteSelect',
  mixins: [userMixin],
  props: {
    label: {
      type: String,
      default: 'Сайты',
    },
    fieldName: { type: String, default: 'site_key' },
    site: { type: String, default: '' },
    hash: { type: Boolean, default: false },
    /// includes hidden input
    input: { type: Boolean, default: true },
    dark: { type: Boolean, default: false },
    push: { type: Boolean, default: false },
    /// indicates that selected site will be sets into global scope
    global: { type: Boolean, default: true },
  },
  data() {
    return {
      sites: [],
      currentSite: { name: 'Федеральный', key: '', title: 'Федеральный' },
    }
  },
  watch: {
    site() {
      this.updateSite()
    },
    currentSite(e) {
      if (this.global) {
        localStorage.setItem('selected-site', e.key)
        this.$log.debug('select site component', e)
        if (this.hash) {
          this.$emit('site-selected', this.currentSite)
          return
        }
        this.$emit('site-selected', this.currentSite)
        this.$localStorage.set('globalSiteKey', this.currentSite.key)
        this.$localStorage.set('globalSiteTitle', this.currentSite.title)
        localStorage.setItem('user-region', this.currentSite.key)
        localStorage.setItem('user-region-title', this.currentSite.title)
        this.globalSiteKey = this.currentSite.key
        this.globalSiteTitle = this.currentSite.key
        this.$route.query.site_key = e.key
        this.$route.params.site_key = e.key
        this.$attrs.site_key = e.key
        this.$attrs.site_title = e.title
      } else {
        this.$emit('site-selected', this.currentSite)
      }
    },
  },
  mounted() {
    this.getSites()
  },
  update() {
    this.getSites()
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.key.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },
    updateSite() {
      if (typeof this.site === 'string' && this.site) {
        for (let i in this.sites) {
          if (this.sites[i].key === this.site) {
            this.currentSite = this.sites[i]
          }
        }
      } else {
        if (this.site) {
          this.currentSite = this.site
        }
      }
    },
    getSites() {
      this.axios({ url: '/v1/sites', method: 'get' })
        .then((resp) => {
          this.sites = resp.data
          this.updateSite()
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
